import React, { Component } from "react";

import { inject, observer } from "mobx-react";

import { Layout, Spin } from "antd";

import "../steps.css";

@inject("translationsStore", "step2RegistrationStore", "registrationStore")
@observer
class Step_2 extends Component {
  constructor(props) {
    super(props);
    if (!this.props.step2RegistrationStore.session) {
      this.props.history.push("/registrations");
    } else if (this.props.registrationStore.status === 2) {
      this.props.step2RegistrationStore.submit().then(() => {
        this.props.history.push("/registration/step_3");
      });
    }
  }

  render() {
    const { current: t } = this.props.translationsStore;
    return (
      <Layout
        hasSider={false}
        style={{ justifyContent: "space-between", minHeight: "100%", padding: "10px" }}
        className="Step_2 Steps"
      >
        <Spin />
      </Layout>
    );
  }
}

export default Step_2;



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_2/Step_2.js